// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".h-slider[data-v-1b7f47d6]{height:102px}@media (min-width: 768px){.h-slider[data-v-1b7f47d6]{height:54px}}.hover-top-news-slider-button[data-v-1b7f47d6]:hover{box-shadow:0 2px 4px rgba(0,0,0,.16)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
